<div class="officeholder-name" [class.show-change]="pendingButtonState">
  @if (model.showAppointedNotLodged) {
    <div class="prop current">{{ model.officeholderName }}</div>
  } @else if (model.showNameChanged) {
    <div class="prop previous">{{ model.previousOfficeholderName }}</div>
    <div class="prop current">{{ model.officeholderName }}</div>
  } @else if (model.showOfficerCeased) {
    <div class="prop cease">{{ model.previousOfficeholderName }}</div>
  } @else {
    <div class="prop">{{ model.previousOfficeholderName | defaultValue }}</div>
  }
</div>
